import classNames from 'classnames';
import { ButtonTheme } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';

import './EditorControlsDecorator.css';

export interface EditorControlsDecoratorProps {
    cls?: string;
    submitButtonText: string;
    submitButtonTheme?: ButtonTheme;
    cancelButtonText: string;
    cancelButtonTheme?: ButtonTheme;
    submitDisabled?: boolean;
    submitVisible?: boolean;
    onSubmitClick: () => void;
    onCancelClick: () => void;
}

const BLOCK = 'editor-controls';

export const EditorControlsDecorator = React.memo(
    ({
        cls,
        submitButtonText,
        submitButtonTheme = 'pseudo',
        cancelButtonText,
        cancelButtonTheme = 'pseudo',
        submitDisabled,
        onSubmitClick,
        onCancelClick,
        submitVisible = true
    }: EditorControlsDecoratorProps) => {
        return (
            <div className={classNames(BLOCK, cls)}>
                {submitVisible && (
                    <ButtonDecorator
                        cls={classNames(Bem.cls(BLOCK, 'submit-button'), TestBem.cls(BLOCK, 'submit-button'))}
                        theme={submitButtonTheme}
                        disabled={submitDisabled}
                        size="n"
                        text={submitButtonText}
                        view="classic"
                        onClick={onSubmitClick}
                    />
                )}

                <ButtonDecorator
                    cls={Bem.cls(BLOCK, 'cancel-button')}
                    theme={cancelButtonTheme}
                    size="n"
                    text={cancelButtonText}
                    view="classic"
                    onClick={onCancelClick}
                />
            </div>
        );
    }
);
